module.exports = __webpack_public_path__ + "images/wink-licky.png";